export default "__VITE_ASSET__80764dae__"